//core
import React, { useRef } from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";

//icons
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Theme} from "@mui/material/styles/createTheme";
import Contact from "../Contact";

const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    color: 'inherit',
  },
  text: {
    whiteSpace: 'nowrap',
    color: 'inherit',
    '& a': {
      color: 'var(--text-primary)',
      maxWidth: 140,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
    '& span': {
      maxWidth: 160,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
  },
  icon: {
    width: 16,
    height: 16,
    color: theme.palette.action.active,
    '& svg': {
      width: 16,
      height: 16,
    }
  },
  wrapper: {
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  messenger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: "100%",
    gap: 4,
  },
}));

interface IMessengerItem {
  messenger: {
    type: string;
    value: string;
  },
  isPublic: boolean;
}

interface IContact {
  value: IMessengerItem[];
  className?: string;
}


const ArrayOfCashierMessengers: React.FC<IContact> = ({ value, className = '' }): JSX.Element => {
  const styles = useStyles();
  const wrapperRef: any = useRef(null);

  return (
    <>
      <Box ref={wrapperRef} className={styles.wrapper}>
        {value.length > 0 ? (
          <>
            {value.map((item, i) => {
              const messengerValue = JSON.parse(item.messenger.value);
              const value = item.messenger.type === 'other'
                ? `${messengerValue.name} - ${messengerValue.value}`
                : messengerValue.value;

              return (
                <Box key={`${item.messenger.type}-${i}`} className={styles.messenger}>
                  <Box>
                    <Contact type={item.messenger.type} value={`${value}`} />
                  </Box>
                  {item.isPublic && <VisibilityOffIcon color="primary" style={{ fontSize: '16px' }} />}
                </Box>
              )
            })}
          </>
        ) : (
          <>{'—'}</>
        )}
      </Box>
    </>
  );
};

export default ArrayOfCashierMessengers;
